import { Action } from 'redux';
import * as shallowEqual from 'shallowequal';

import { isAvailableActionForEntityRequestSucceededAction } from '../actions/spaces/AvailableActionsForEntityActions';
import { AvailableActionsForEntityState } from '../state/AvailableActionsForEntityState';

export function availableActionsForEntityReducer(
  previousState: AvailableActionsForEntityState = null,
  action: Action = null
): AvailableActionsForEntityState {
  if (isAvailableActionForEntityRequestSucceededAction(action)) {
    const previousEntity = previousState ? previousState.entity : null;
    const previousActions = previousState ? previousState.availableActions : null;
    const newEntity = { contentType: action.entityType, id: action.entityId };
    const newActions = action.availableActions;
    const newState = {
      entity: shallowEqual(previousEntity, newEntity) ? previousEntity : newEntity,
      availableActions: shallowEqual(previousActions, newActions) ? previousActions : newActions
    };

    return shallowEqual(previousState, newState) ? previousState : newState;
  }

  return previousState;
}
